var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'join-edit',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      join: {
        join_class: null
      }
    }
  },
  computed: {
    joins () {
      return this.$store.getters.join
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    validation: function() {
      var v = {
        join_class: !!this.joins.data.attributes['join-class'],
        not_input: !!this.joins.data.attributes['join-class']
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        console.log("is valid")
        var data = {
          join_class: this.joins.data.attributes['join-class']
        }
        this.$store.dispatch('JOIN_UPDATE', { id: this.$route.params.id, data: data, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/joins', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      data.callback = function () {
      }
      this.$store.dispatch('JOIN_EDIT',  {id: this.$route.params.id, data: data})
    },
    half: function () {
      this.joins.data.attributes['join-class'] = utils.emHalf(this.joins.data.attributes['join-class'])
    },
    onSaved: function (result) {
      this.$router.push({ path: '/joins/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/join-edit.js